<template>
	<div class="file-setting-body">
		<div class="fx-header">
			<p>基本档案设置</p>
		</div>
		<div class="file-setting-container">
			<el-collapse v-model="activeNames">
				<el-collapse-item title="商品基础档案" class="file-item" name="2">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">私密状态：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="privateflagChange" v-model="privateflag">
								<el-option :value='0' label="公开"></el-option>
								<el-option :value='1' label="私密"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">使用最小订货数倍数订货：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="minordercountflagChange" v-model="minordercountflag">
								<el-option :value='1' label="使用最小订货数倍数订货"></el-option>
								<el-option :value='0' label="不使用"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%" v-if="matchbillcenterflag">
						<div style="width:50%;">
							<div class="span-box">对接订单中台商品档案是否自动同步：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="autoflagChange" v-model="productAutoSyncFlag">
								<el-option :value='0' label="不同步"></el-option>
								<el-option :value='1' label="同步"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">商品促销标签：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="productSaleMarkChange" v-model="productSaleMark">
								<el-option :value='0' label="可售商品库"></el-option>
								<el-option :value='1' label="商品折扣活动"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">默认购买方式：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="defaultPurchaseWayChange" v-model="defaultPurchaseWay">
								<el-option :value='0' label="按列表采购"></el-option>
								<el-option :value='1' label="按规格采购"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%" v-if="!matchbillcenterflag">
						<div style="width:50%;">
							<div class="span-box">成本价格：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="costshowflagChange" v-model="costshowflag">
								<el-option :value='0' label="关闭"></el-option>
								<el-option :value='1' label="开启"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="店铺级分类" class="file-item" name="3">
					<div style="width:100%;display:flex;">
						<div style="width:50%;">
							<div class="span-box">店铺级小类：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="classflagChange" v-model="classflag">
								<el-option :value='1' label="开启"></el-option>
								<el-option :value='0' label="关闭"></el-option>
							</el-select>
						</div>
						<div style="width:50%;">
							<div class="span-box">三级类别：</div>
							<el-select class="select-box" size='mini' :disabled="thirdCategoryDisabled" @change="thirdcategoryviewChange" v-model="thirdcategoryview">
								<el-option :value='1' label="开启"></el-option>
								<el-option :value='0' label="关闭"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="客户档案" class="file-item" name="4">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">新建客户支付方式：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" multiple collapse-tags @change="payTypeflagChange" v-model="payTypeflag">
								<!-- <el-option value='0' label="不限"></el-option> -->
								<el-option value='2' label="微信支付"></el-option>
								<el-option value='0' label="线下支付"></el-option>
								<el-option value='4' label="预付货款"></el-option>
								<el-option value='6' label="微企付"></el-option>
								<el-option value='7' label="云资金-网商余额支付"></el-option>
								<el-option value='8' label="云资金-汇付支付"></el-option>
								<el-option value='9' label="云资金-中信支付"></el-option>
								<el-option value='11' label="B2b门店助手-微信支付"></el-option>
								<el-option value='12' label="B2b门店助手-银行转账"></el-option>
								<el-option value="13" label="云资金-网商收银台"></el-option>
								<el-option value="14" label="拉卡拉全渠道-余额支付"></el-option>
								<el-option value="16" label="拉卡拉钱包余额"></el-option>
								<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--								<el-option value="15" label="拉卡拉全渠道-收银台"></el-option>-->
								<!-- <el-option value='10' label="云资金-富友账户通支付"></el-option> -->
							</el-select>
						</div>
					</div>
					<div style="width:100%">
						<div style="width:60%;">
							<div class="span-box">是否只允许客户专有价格下单：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="mustspecialpriceflagChange" v-model="mustspecialpriceflag">
								<el-option :value='0' label="不限制"></el-option>
								<el-option :value='1' label="只允许专有价格下单"></el-option>
								<el-option :value='2' label="只允许按客户等级下单"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%" v-if="mustspecialpriceflag === 1">
						<div style="width:60%;">
							<div class="span-box">生效私密状态：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="specialpricehiddenflagChange" v-model="specialpricehiddenflag">
								<el-option :value='0' label="全部"></el-option>
								<el-option :value='1' label="仅私密商品"></el-option>
								<el-option :value='2' label="仅公开商品"></el-option>
							</el-select>
						</div>
					</div>
					<div class="desc-span" v-if="mustspecialpriceflag === 0" style="color:red;margin-left:50px">*客户有专有价格,则按照专有价格下单;没有专有价格,则按照市场价格下单</div>
					<div class="desc-span" v-if="mustspecialpriceflag === 1 && specialpricehiddenflag === 0" style="color:red;margin-left:50px">*客户有专有价格,则按照专有价格下单;没有专有价格,则无法下单</div>
					<div class="desc-span" v-if="mustspecialpriceflag === 1 && specialpricehiddenflag !== 0" style="color:red;margin-left:50px">*生效私密状态非全部时，仅选择的私密状态的商品须专有价格下单，没有专有价格无法下单；未选择的私密状态优先获取专有价格，没有专有价格,则按照市场价格下单。</div>
					<div style="width:100%" v-if="matchbillcenterflag">
						<div style="width:60%;" class="flex-center">
							<div class="span-box">是否对接中台价格方案：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="priceflagChange" v-model="matchbillcenterpriceflag">
								<el-option :value='1' label="使用订单中台价格方案"></el-option>
								<el-option :value='0' label="自定义客户价格档案"></el-option>
							</el-select>
							<div class="flex-center" v-if="matchbillcenterpriceflag === 1">
								<el-switch
									@change="matchbillcenterpricewholeflagChange"
									v-model="matchbillcenterpricewholeflag"
									:disabled="!AuthorityList['06_0001_0004_00']"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									style="margin: 0 10px">
								</el-switch>
								<span>开启专有价格参数</span>
							</div>
						</div>
					</div>
					<div style="width:100%">
						<div>
							<div class="span-box">隐藏获取价格失败的商品：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="productHideNoPriceFlagChange" v-model="productHideNoPriceFlag">
								<el-option :value='1' label="是"></el-option>
								<el-option :value='0' label="否"></el-option>
							</el-select>
						</div>
					</div>
					<div class="desc-span" v-if="matchbillcenterpriceflag === 1" style="color:red;margin-left:50px">*使用订单中台价格方案,则本系统的价格成只读状态,不可新建、编辑</div>
					<div style="width:100%">
						<div style="width:60%;">
							<div class="span-box">预付货款账户：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="prepaymentdefaultaccountChange" v-model="prepaymentdefaultaccount">
								<el-option :value='0' label="本系统"></el-option>
								<el-option v-if="matchbillcenterflag && souretype === 2001" :value='1' label="供应链系统"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%" v-if="matchbillcenterpriceflag !== 1">
						<div style="display:flex;align-items: center;">
							<div class="span-box">专有价格失效提醒预警：</div>
							<el-switch
								@change="privatePriceWarningFlagChange"
								v-model="privatePriceWarningFlag"
								:disabled="!AuthorityList['06_0001_0004_00']"
								active-color="#13ce66"
								:active-value="1"
								:inactive-value="0">
							</el-switch>
							<el-input v-if="privatePriceWarningFlag === 1" size="mini" @blur="blurMethod" style="margin:0 10px" v-model="privatePriceWarningDays" class="select-box"></el-input>
							<span v-if="privatePriceWarningFlag === 1">天,显示预警</span>
						</div>
						<div class="desc-span" style="color:red;margin-left:50px">*输入内容限制为非零整数123456789...，举例：如果预警时间设置为1天，失效时间是2022-02-09 00:00:00，则2022-02-08 00:00:01提醒。</div>
					</div>
					<div style="width:100%">
						<div>
							<div class="span-box">是否自动扣款/积分：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="autopaybypremoneyChange" v-model="autopaybypremoney">
								<el-option :value='true' label="允许"></el-option>
								<el-option :value='false' label="不允许"></el-option>
							</el-select>
							<div class="desc-span" style="color:red;margin-left:50px">*1、自动扣款订单状态:财务审核、待发货、待收货、已完成。2、当前仅支持︰支付方式为预付货款的订单。3、当客户余额不足时，需要客户手动支付。注︰建议和订货客户签订自动扣款协议合同再进行开启，否则容易引起法律纠纷，极速订不承担此法律风险。</div>
						</div>
					</div>
					<div style="width:100%">
						<div>
							<div class="span-box">收货地址是否允许客户维护：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="buyermodifyaddressChange" v-model="buyermodifyaddress">
								<el-option :value='1' label="允许"></el-option>
								<el-option :value='0' label="不允许"></el-option>
							</el-select>
							<div class="addr-set" v-if="buyermodifyaddress === 1" @click="addrSet">设置</div>
						</div>
					</div>
					<div style="width:100%">
						<div>
							<div class="span-box">后台修改客户密码短信通知：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="smsCustomerOrUserFlagChange" v-model="smsCustomerOrUserFlag">
								<el-option :value='1' label="允许"></el-option>
								<el-option :value='0' label="不允许"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="小数设置" class="file-item" name="5">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">卖家后台订发货商品数量保留几位小数：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="decimalCountChange" v-model="decimalCount">
								<el-option :value='0' label="0位小数"></el-option>
								<el-option :value='1' label="1位小数"></el-option>
								<el-option :value='2' label="2位小数"></el-option>
								<el-option :value='3' label="3位小数"></el-option>
								<el-option :value='4' label="4位小数"></el-option>
							</el-select>
						</div>
						<div style="width:50%;">
							<div class="span-box">买家小程序订发货商品数量保留几位小数：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="orderAPPDecimalCountChange" v-model="orderAPPDecimalCount">
								<el-option :value='0' label="0位小数"></el-option>
								<el-option :value='1' label="1位小数"></el-option>
								<el-option :value='2' label="2位小数"></el-option>
								<el-option :value='3' label="3位小数"></el-option>
								<el-option :value='4' label="4位小数"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="金额计算设置" class="file-item" name="6">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">金额计算取整规则：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="orderNumberRoundRulesChange" v-model="orderNumberRoundRules">
								<el-option :value='0' label="四舍五入"></el-option>
								<el-option :value='1' label="直接抹零"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="订单生成设置" class="file-item" name="7">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">库存不足是否继续下单：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="userinventoryflagChange" v-model="userinventoryflag">
								<el-option :value='1' label="不允许下单"></el-option>
								<el-option :value='0' label="允许下单"></el-option>
							</el-select>
							<!-- <el-tooltip effect="dark" placement="right" popper-class="tip-class">
								<div slot="content">
									库存不足不允许下单场景包括：<br>
									1、买家在小程序下单<br>
									2、卖家在卖家小程序、卖家后台代客下单、批量代客下单、修改订单时编辑商品、添加商品、编辑实收数量（订单状态为已完成）
								</div>
								<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
							</el-tooltip> -->
						</div>
					</div>

					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">订单中商品顺序：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="sorttypeChange" v-model="sorttype">
								<el-option :value='0' label="商品采购顺序"></el-option>
								<el-option :value='1' label="商品分类顺序"></el-option>
							</el-select>
						</div>
					</div>

					<div v-if="matchbillcenterflag" style="width:100%">
						<div style="width:50%;">
							<div class="span-box">是否使用实时库存：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="actualtimeinventoryflagChange" v-model="actualtimeinventoryflag">
								<el-option :value='0' label="不使用实时库存"></el-option>
								<el-option :value='1' label="使用实时库存"></el-option>
							</el-select>
						</div>
					</div>

					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">有未付款单据是否可下单：</div>
							<el-select class="select-box" size='mini' @change="unpaycanorderflagChange" v-model="unpaycanorderflag" :disabled="!AuthorityList['06_0001_0004_00']">
								<el-option :value='0' label="可以下单"></el-option>
								<el-option :value='1' label="小程序不可以下单"></el-option>
								<el-option :value='2' label="小程序、代客下单都不可以下单"></el-option>
							</el-select>
							<el-tooltip effect="dark" placement="right" popper-class="tip-class">
								<div slot="content">
									未支付单据包含：未支付的单据(不包含待付款订单)、子单据
								</div>
								<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
							</el-tooltip>
						</div>
					</div>

					<div v-if="userinventoryflag === 1" style="width:100%">
						<div style="width:50%;">
							<div class="span-box">商品存在辅助单位时是否校验基础单位库存：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="checkassistunitflagChange" v-model="checkassistunitflag" >
								<el-option :value='1' label="是"></el-option>
								<el-option :value='0' label="否"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="代客下单" class="file-item" name="8">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">非赠品商品价格为0时是否允许提交订单：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="createOrderWithZeroPriceFlagChange" v-model="createOrderWithZeroPriceFlag">
								<el-option :value='1' label="允许"></el-option>
								<el-option :value='0' label="不允许"></el-option>
							</el-select>
						</div>
					</div>
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">买家是否允许取消订单：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="canordercancelChange" v-model="canordercancel">
								<el-option :value='0' label="允许"></el-option>
								<el-option :value='1' label="不允许"></el-option>
							</el-select>
							<el-tooltip effect="dark" placement="right" popper-class="tip-class">
								<div slot="content">
									只针对代客下单的场景；选择不允许时，代客下单的订单不受待付款订单失效时间参数控制；即待付款订单不会自动取消
								</div>
								<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
							</el-tooltip>
						</div>
					</div>
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box-big">添加重复商品时，询问设置为赠品或追加、覆盖原有品项数量：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="replaceSameProductMessageFlagChange" v-model="replaceSameProductMessageFlag">
								<el-option :value='1' label="询问"></el-option>
								<el-option :value='0' label="不询问，默认设置为赠品"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item title="预付货款设置" class="file-item" name="8">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">预付货款是否显示赠送金额：</div>
							<el-select class="select-box" size='mini' :disabled="!AuthorityList['06_0001_0004_00']" @change="showgiftChange" v-model="showgift">
								<el-option :value='1' label="允许"></el-option>
								<el-option :value='0' label="不允许"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>
				<!--<el-collapse-item title="电子称设置" class="file-item" name="7">
					<div style="width:100%">
						<div style="width:50%;">
							<div class="span-box">是否对接电子称：</div>
							<el-select class="select-box" size='mini' @change="userinventoryflagChange" v-model="userinventoryflag">
								<el-option :value='0' label="否"></el-option>
								<el-option :value='1' label="是"></el-option>
							</el-select>
						</div>
						<div style="width:50%;">
							<div class="span-box">称重换算商品计算规则：</div>
							<el-select class="select-box" size='mini' @change="userinventoryflagChange" v-model="userinventoryflag">
								<el-option :value='0' label="四舍五入"></el-option>
								<el-option :value='1' label="直接抹零"></el-option>
							</el-select>
						</div>
					</div>
				</el-collapse-item>-->
			</el-collapse>
			<el-dialog
				title="预付货款账户切换提示"
				:visible.sync="tipModel"
				class="tip-modal"
				:close-on-click-modal="false"
				width="500px">
					<div style="display:flex;flex-direction: column;text-align: left;">
						<div class="title">您确定要切换吗？</div>
						<div class="content">1、切换后，极速订仅可查询、使用切换后的系统余额</div>
						<div class="content">2、切换后，预付货款充值直接充值到切换后的系统</div>
						<div class="content">3、切换后，预付货款余额收支明细来源为切换后的系统</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="cancelClick">取 消</el-button>
						<el-button size="mini" type="primary" @click="savePrepaymentdefaultaccount">确 定</el-button>
					</span>
			</el-dialog>
			<el-dialog
				title="可维护收货地址设置"
				:visible.sync="addrModel"
				class="addr-modal"
				:close-on-click-modal="true"
				width="500px">
					<div>
						<el-tree
							:data="addrData"
							show-checkbox
							node-key="id"
							ref="tree"
							:default-expanded-keys="[2]"
							:default-checked-keys="defaultCheckArr"
							:props="defaultProps">
						</el-tree>
					</div>
					<span slot="footer">
						<el-button size="mini" @click="cancelAddrClick">取 消</el-button>
						<el-button size="mini" type="primary" @click="saveAddrSet">确 定</el-button>
					</span>
			</el-dialog>
			<el-dialog
				title="提示"
				:visible.sync="matchbillModel"
				class="tip-modal"
				:close-on-click-modal="false"
				width="600px">
					<div class="match-content">
						打开专有价格参数，如果获取不到中台价格时，将会根据该参数所选的选项取极速订中设置的品项不同的价格；<span style="color:red">不建议</span>将该参数选择“不限制”，如果选择不限制，若品项未在极速订维护专有价格、等级价格时，将取极速订品项销售价，<span style="color:red">若未在极速订维护销售价时，品项会显示0元，即买家无需支付金额即可下单</span>，请谨慎操作！是否确认开启专有价格参数？
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="cancelMatch">取 消</el-button>
						<el-button size="mini" type="primary" @click="confirmMatch">确 定</el-button>
					</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
export default {
	name: 'fileSetting',
	data () {
		return {
			souretype: 0,
			privatePriceWarningDays: '',
			privatePriceWarningFlag: 0,
			userinventoryflag: 1,
			minordercountflag: 0,
			privateflag: 0,
			activeNames: ['1', '2', '3', '4', '5', '6', '7', '8'],
			clddock: false,
			newbaseinfo: false,
			AuthorityList: {
				'06_0001_0003_00': false,
				'06_0001_0004_00': false
			},
			classflag: 1,
			thirdcategoryview: 0,
			payTypeflag: ['2', '4', '5'],
			orginPaymodes: ['2', '4', '5'],
			decimalCount: 0,
			orderAPPDecimalCount: 0,
			orderNumberRoundRules: 0,
			productAutoSyncFlag: 0,
			sorttype: 0,
			matchbillcenterpriceflag: 1,
			matchbillcenterflag: false,
			mustspecialpriceflag: 0,
			actualtimeinventoryflag: 0,
			prepaymentdefaultaccount: 0,
			productHideNoPriceFlag: 0,
			ruleForm: {},
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			unpaycanorderflag: 0,
			checkassistunitflag: 0,
			canpaylater: false,
			tipModel: false,
			autopaybypremoney: false,
			createOrderWithZeroPriceFlag: 0,
			buyermodifyaddress: 0,
			productSaleMark: 0,
			defaultPurchaseWay: 0,
			showgift: 1,
			specialpricehiddenflag: 0,
			costshowflag: 0,
			canordercancel: 0,
			replaceSameProductMessageFlag: 0,
			addrModel: false,
			addrData: [{
				id: 1,
				label: '新增收货地址'
			}, {
				id: 2,
				label: '编辑收货地址',
				children: [{
					id: 3,
					label: '收货人姓名'
				}, {
					id: 4,
					label: '手机号码'
				}, {
					id: 5,
					label: '省市区'
				}, {
					id: 6,
					label: '街道地址'
				}, {
					id: 7,
					label: '详细地址'
				}]
			}],
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			defaultCheckArr: [1, 2, 3, 4, 5, 6, 7],
			smsCustomerOrUserFlag: 0,
			matchbillcenterpricewholeflag: 0,
			matchbillModel: false
		}
	},
	computed: {
		thirdCategoryDisabled () {
			return !this.AuthorityList['06_0001_0003_00'] || this.classflag !== 1
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '7-1')
		this.getInfo()
		this.getAuthority('06_0002_0000_00')
	},
	methods: {
		privatePriceWarningFlagChange () {
			let formData = new FormData()
			formData.append('privatePriceWarningFlag', this.privatePriceWarningFlag)
			this.ruleForm.privatePriceWarningFlag = this.privatePriceWarningFlag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setPrivatePriceWarningFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		matchbillcenterpricewholeflagChange (event) {
			if (event === 1) {
				this.matchbillModel = true
			} else {
				this.confirmMatch()
			}
		},
		cancelMatch () {
			this.matchbillcenterpricewholeflag = 0
			this.matchbillModel = false
		},
		confirmMatch () {
			const preState = this.matchbillcenterpricewholeflag === 1 ? '不开启' : '开启'
			const curState = this.matchbillcenterpricewholeflag === 0 ? '不开启' : '开启'
			let loggerMessage = `是否开启专有价格参数由"${preState}"改为"${curState}"`
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			const params = {
				matchbillcenterpricewholeflag: this.matchbillcenterpricewholeflag,
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setMatchBillCenterPriceWholeFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.matchbillModel = false
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		blurMethod () {
			this.privatePriceWarningDays = this.$fxUtils.toFixedSHW(this.privatePriceWarningDays, 0)
			if (this.privatePriceWarningDays === '' || this.privatePriceWarningDays === 0) {
				this.privatePriceWarningDays = 1
			}
			let formData = new FormData()
			formData.append('privatePriceWarningDays', this.privatePriceWarningDays)
			this.ruleForm.privatePriceWarningDays = this.privatePriceWarningDays
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setPrivatePriceWarningDays`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		cancelClick () {
			this.tipModel = false
			this.getInfo()
		},
		savePrepaymentdefaultaccount () {
			let formData = new FormData()
			formData.append('prepaymentdefaultaccount', this.prepaymentdefaultaccount)
			this.ruleForm.prepaymentdefaultaccount = this.prepaymentdefaultaccount
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setprepaymentdefaultaccount`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.tipModel = false
					this.getInfo()
				} else {
					this.$message.error(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		prepaymentdefaultaccountChange () {
			this.tipModel = true
		},
		actualtimeinventoryflagChange () {
			let formData = new FormData()
			formData.append('actualtimeinventoryflag', this.actualtimeinventoryflag)
			this.ruleForm.actualtimeinventoryflag = this.actualtimeinventoryflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setActualTimeInventoryFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$fxEventBus.$emit('showInventory', this.actualtimeinventoryflag)
					let params = {
						app: 'jsd',
						action: 'refreshMenu',
						data: ''
					}
					window.parent.postMessage(params, '*')
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		sorttypeChange () {
			let formData = new FormData()
			formData.append('sorttype', this.sorttype)
			this.ruleForm.sorttype = this.sorttype
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setSortType`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		checkassistunitflagChange () {
			let formData = new FormData()
			formData.append('checkassistunitflag', this.checkassistunitflag)
			this.ruleForm.checkassistunitflag = this.checkassistunitflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setcheckassistunitflag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		unpaycanorderflagChange () {
			let formData = new FormData()
			formData.append('unpaycanorderflag', this.unpaycanorderflag)
			this.ruleForm.unpaycanorderflag = this.unpaycanorderflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setUnPayCanOrderFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		userinventoryflagChange () {
			let formData = new FormData()
			formData.append('userinventoryflag', this.userinventoryflag)
			this.ruleForm.userinventoryflag = this.userinventoryflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setUserInventoryFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		minordercountflagChange () {
			let formData = new FormData()
			formData.append('minordercountflag', this.minordercountflag)
			this.ruleForm.minordercountflag = this.minordercountflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setMinordercountflag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 分类切换
		classflagChange (e) {
			if (e === 0) {
				this.$confirm(`关闭店铺级小类后，若店铺已产生订单，则不能再开启店铺级小类！`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.classHandle()
				}).catch(() => {
					this.classflag = 1
				})
			} else {
				this.classHandle()
			}
		},
		classHandle () {
			let formData = new FormData()
			formData.append('bigcategoryview', this.classflag)
			this.ruleForm.classflag = this.classflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/smallcategoryview`,
				data: formData,
				logger
			}).then(res => {
				if (res.res) {
					const needCloseThird = this.classflag === 0 && this.thirdcategoryview === 1
					if (needCloseThird) {
						this.thirdcategoryview = 0
						this.saveThirdCategoryView().then(() => {
							this.$message.success(res.msg)
							this.getInfo()
						})
					} else {
						this.$message.success(res.msg)
						this.getInfo()
					}
				} else {
					this.classflag = 0
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		thirdcategoryviewChange () {
			if (this.classflag !== 1) {
				this.thirdcategoryview = this.ruleForm.thirdcategoryview || 0
				this.$message.warning('请先开启店铺级小类')
				return
			}
			if (!this.AuthorityList['06_0001_0003_00']) {
				this.thirdcategoryview = this.ruleForm.thirdcategoryview || 0
				return
			}
			this.saveThirdCategoryView().then(res => {
				if (res.res) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.thirdcategoryview = this.ruleForm.thirdcategoryview || 0
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		saveThirdCategoryView () {
			let formData = new FormData()
			formData.append('thirdcategoryview', this.thirdcategoryview)
			this.ruleForm.thirdcategoryview = this.thirdcategoryview
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/thirdcategoryview`,
				data: formData,
				logger
			})
		},
		createOrderWithZeroPriceFlagChange () {
			let formData = new FormData()
			formData.append('createOrderWithZeroPriceFlag', this.createOrderWithZeroPriceFlag)
			this.ruleForm.createOrderWithZeroPriceFlag = this.createOrderWithZeroPriceFlag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCreateOrderWithZeroPriceFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		replaceSameProductMessageFlagChange () {
			let formData = new FormData()
			formData.append('replaceSameProductMessageFlag', this.replaceSameProductMessageFlag)
			this.ruleForm.replaceSameProductMessageFlag = this.replaceSameProductMessageFlag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setReplaceSameProductMessageFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 代客下单买家是否允许取消订单
		canordercancelChange () {
			let formData = new FormData()
			formData.append('canOrderCancel', this.canordercancel)
			this.ruleForm.canordercancel = this.canordercancel
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCanOrderCancel`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 预付货款是否显示赠送金额
		showgiftChange () {
			let formData = new FormData()
			formData.append('showgift', this.showgift)
			this.ruleForm.showgift = this.showgift
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setShowgift`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		privateflagChange () {
			let formData = new FormData()
			formData.append('privateflag', this.privateflag)
			this.ruleForm.privateflag = this.privateflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/privateflag`,
				data: formData,
				logger
			}).then(res => {
				if (res.res) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		mustspecialpriceflagChange () {
			let formData = new FormData()
			formData.append('mustspecialpriceflag', this.mustspecialpriceflag)
			this.ruleForm.mustspecialpriceflag = this.mustspecialpriceflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setMustSpecialPriceFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		productHideNoPriceFlagChange () {
			let formData = new FormData()
			formData.append('productHideNoPriceFlag', this.productHideNoPriceFlag)
			this.ruleForm.productHideNoPriceFlag = this.productHideNoPriceFlag
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setProductHideNoPriceFlag`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		specialpricehiddenflagChange () {
			let formData = new FormData()
			formData.append('specialpricehiddenflag', this.specialpricehiddenflag)
			this.ruleForm.specialpricehiddenflag = this.specialpricehiddenflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setSpecialPriceHiddenFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		payTypeflagChange () {
			let list = []
			let has2 = this.payTypeflag.indexOf('2') !== -1
			let has6 = this.payTypeflag.indexOf('6') !== -1
			let orginHas2 = this.orginPaymodes.indexOf('2') !== -1
			let orginHas6 = this.orginPaymodes.indexOf('6') !== -1
			if (!orginHas6 && has6) {
				this.payTypeflag.forEach(item => {
					if (item !== '2') {
						list.push(item)
					}
				})
				this.payTypeflag = list
			}
			if (!orginHas2 && has2) {
				this.payTypeflag.forEach(item => {
					if (item !== '6') {
						list.push(item)
					}
				})
				this.payTypeflag = list
			}
			let formData = new FormData()
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			let referer = url
			formData.append('customerDefaultPaymodes', this.payTypeflag.join(','))
			formData.append('referer', referer)
			this.ruleForm.payTypeflag = this.payTypeflag
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCustomerDefaultPaymode`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		priceflagChange () {
			let formData = new FormData()
			formData.append('matchbillcenterpriceflag', this.matchbillcenterpriceflag)
			this.ruleForm.matchbillcenterpriceflag = this.matchbillcenterpriceflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setMatchBillCenterPriceFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		autopaybypremoneyChange () {
			let formData = new FormData()
			formData.append('autopaybypremoney', this.autopaybypremoney)
			this.ruleForm.autopaybypremoney = this.autopaybypremoney
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setAutopaybypremoney`,
				data: formData,
				logger
			}).then(res => {
				if (res.res) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		buyermodifyaddressChange () {
			let formData = new FormData()
			formData.append('buyermodifyaddress', this.buyermodifyaddress)
			this.ruleForm.buyermodifyaddress = this.buyermodifyaddress
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setBuyermodifyaddress`,
				data: formData,
				logger
			}).then(res => {
				if (res.res) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 修改密码短信通知
		smsCustomerOrUserFlagChange () {
			let formData = new FormData()
			formData.append('smsCustomerOrUserFlag', this.smsCustomerOrUserFlag)
			this.ruleForm.smsCustomerOrUserFlag = this.smsCustomerOrUserFlag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setSmsCustomerOrUserFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 维护地址设置
		addrSet () {
			this.addrModel = true
		},
		cancelAddrClick () {
			this.addrModel = false
		},
		saveAddrSet () {
			console.log(this.$refs.tree.getCheckedKeys())
			const addr = this.$refs.tree.getCheckedKeys()
			let oriAddr = this.originAddr
			let msg = '收货地址是否允许买家维护：设置：由' + this.addrHandle(oriAddr) + '修改为' + this.addrHandle(addr)
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			let formData = new FormData()
			formData.append('buyermodifyaddressdetail', addr.join(','))
			formData.append('message', msg)
			formData.append('referer', url)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setbuyermodifyaddressdetail`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.addrModel = false
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		addrHandle (item) {
			const checkName = ['新增收货地址', '编辑收货地址', '收货人姓名', '手机号码', '省市区', '街道地址', '详细地址']
			let arr = []
			item.forEach(item => {
				arr.push(checkName[item - 1])
			})
			return '【' + arr.join(',') + '】'
		},
		autoflagChange () {
			let formData = new FormData()
			formData.append('productAutoSyncFlag', this.productAutoSyncFlag)
			this.ruleForm.productAutoSyncFlag = this.productAutoSyncFlag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setProductAutoSyncFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		orderAPPDecimalCountChange () {
			let formData = new FormData()
			formData.append('orderAPPDecimalCount', this.orderAPPDecimalCount)
			this.ruleForm.orderAPPDecimalCount = this.orderAPPDecimalCount
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setOrderAPPDecimalCount`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.getInfo()
			})
		},
		decimalCountChange () {
			let formData = new FormData()
			formData.append('orderDecimalCount', this.decimalCount)
			this.ruleForm.decimalCount = this.decimalCount
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setOrderDecimalCount`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
					this.getInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.getInfo()
			})
		},
		orderNumberRoundRulesChange () {
			let formData = new FormData()
			formData.append('orderMoneyRoundRules', this.orderNumberRoundRules)
			this.ruleForm.orderNumberRoundRules = this.orderNumberRoundRules
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setOrderMoneyRoundRules`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		productSaleMarkChange () {
			let formData = new FormData()
			formData.append('productSaleMark', this.productSaleMark)
			this.ruleForm.productSaleMark = this.productSaleMark
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setProductSaleMark`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		defaultPurchaseWayChange () {
			let formData = new FormData()
			formData.append('defaultPurchaseWay', this.defaultPurchaseWay)
			this.ruleForm.defaultPurchaseWay = this.defaultPurchaseWay
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setDefaultPurchaseWay`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		costshowflagChange () {
			let formData = new FormData()
			formData.append('costShowFlag', this.costshowflag)
			this.ruleForm.costshowflag = this.costshowflag
			const logger = this.$fxLogger.createInfo('system.basic-file.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCostShowFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		getInfo () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findallbasicinfo`
			}).then(res => {
				if (res.result) {
					this.privatePriceWarningFlag = res.data.privatePriceWarningFlag
					this.privatePriceWarningDays = res.data.privatePriceWarningDays
					this.sorttype = res.data.sorttype
					this.userinventoryflag = res.data.userinventoryflag
					this.prepaymentdefaultaccount = res.data.prepaymentdefaultaccount
					this.productHideNoPriceFlag = res.data.pmdata.productHideNoPriceFlag
					this.minordercountflag = res.data.minordercountflag
					this.clddock = res.data.clddock === 1
					this.newbaseinfo = res.data.newbaseinfo === 0
					this.privateflag = res.data.privateflag
					this.classflag = res.data.smallcategoryview
					this.thirdcategoryview = res.data.thirdcategoryview || 0
					if (this.classflag !== 1) {
						this.thirdcategoryview = 0
					}
					this.decimalCount = res.data.orderDecimalCount
					this.orderAPPDecimalCount = res.data.orderAPPDecimalCount
					this.orderNumberRoundRules = res.data.ordermoneyroundrules
					this.productAutoSyncFlag = res.data.productAutoSyncFlag
					this.matchbillcenterflag = res.data.matchbillcenterflag === 1
					this.matchbillcenterpriceflag = res.data.matchbillcenterpriceflag
					this.mustspecialpriceflag = res.data.mustspecialpriceflag
					this.actualtimeinventoryflag = res.data.actualtimeinventoryflag
					this.payTypeflag = res.data.customerdefaultpaymodes
					this.orginPaymodes = res.data.customerdefaultpaymodes
					this.unpaycanorderflag = res.data.unpaycanorderflag
					this.checkassistunitflag = res.data.checkassistunitflag
					this.canpaylater = res.data.canpaylater
					this.autopaybypremoney = res.data.autopaybypremoney
					this.createOrderWithZeroPriceFlag = res.data.createOrderWithZeroPriceFlag
					this.buyermodifyaddress = res.data.buyermodifyaddress
					this.productSaleMark = res.data.productSaleMark
					this.defaultPurchaseWay = res.data.defaultPurchaseWay === null ? 0 : res.data.defaultPurchaseWay
					this.showgift = res.data.showgift
					this.specialpricehiddenflag = res.data.specialpricehiddenflag
					this.costshowflag = res.data.costshowflag
					this.canordercancel = res.data.canordercancel
					this.replaceSameProductMessageFlag = res.data.replaceSameProductMessageFlag
					this.defaultCheckArr = res.data.buyermodifyaddressdetail !== null ? res.data.buyermodifyaddressdetail.split(',') : [1, 2, 3, 4, 5, 6, 7]
					this.originAddr = this.$fxUtils.deepClone(this.defaultCheckArr)
					this.smsCustomerOrUserFlag = res.data.smsCustomerOrUserFlag
					this.matchbillcenterpricewholeflag = res.data.matchbillcenterpricewholeflag
					this.souretype = res.data.souretype
					this.ruleForm = {
						productHideNoPriceFlag: res.data.pmdata.productHideNoPriceFlag,
						privatePriceWarningFlag: res.data.privatePriceWarningFlag,
						privatePriceWarningDays: res.data.privatePriceWarningDays,
						sorttype: res.data.sorttype,
						userinventoryflag: res.data.userinventoryflag,
						minordercountflag: res.data.minordercountflag,
						clddock: res.data.clddock === 1,
						newbaseinfo: res.data.newbaseinfo === 0,
						privateflag: res.data.privateflag,
						classflag: res.data.smallcategoryview,
						thirdcategoryview: this.thirdcategoryview,
						decimalCount: res.data.orderDecimalCount,
						orderAPPDecimalCount: res.data.orderAPPDecimalCount,
						orderNumberRoundRules: res.data.ordermoneyroundrules,
						productAutoSyncFlag: res.data.productAutoSyncFlag,
						matchbillcenterflag: res.data.matchbillcenterflag === 1,
						matchbillcenterpriceflag: res.data.matchbillcenterpriceflag,
						mustspecialpriceflag: res.data.mustspecialpriceflag,
						actualtimeinventoryflag: res.data.actualtimeinventoryflag,
						payTypeflag: res.data.customerdefaultpaymode,
						unpaycanorderflag: res.data.unpaycanorderflag,
						checkassistunitflag: res.data.checkassistunitflag,
						autopaybypremoney: res.data.autopaybypremoney,
						createOrderWithZeroPriceFlag: res.data.createOrderWithZeroPriceFlag,
						productSaleMark: res.data.productSaleMark,
						defaultPurchaseWay: res.data.defaultPurchaseWay === null ? 0 : res.data.defaultPurchaseWay,
						showgift: res.data.showgift,
						specialpricehiddenflag: res.data.specialpricehiddenflag,
						costshowflag: res.data.costshowflag,
						canordercancel: res.data.canordercancel,
						replaceSameProductMessageFlag: res.data.replaceSameProductMessageFlag,
						smsCustomerOrUserFlag: res.data.smsCustomerOrUserFlag
					}
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.file-setting-body {
	display: flex;
	flex-direction: column;
	.file-setting-container {
		display flex;
		flex-direction: column;
		overflow-y:auto
		.fx-title {
			span {
				font-size: 16px;
			}
		}
		.tip-icon {
			display: inline-block;
			margin-left: 5px;
			cursor: pointer
		}
		.el-collapse {
			border-top: none
			width: 100%;
			.file-item {
				.select-box{
					width:180px
				}
				.span-box-big{
					text-align :right;
					display: inline-block;
					width :400px
				}
				.span-box{
					text-align :right;
					display: inline-block;
					width :270px
				}
				.flex-center {
					display: flex;
					align-items: center
				}
				.desc-span {
					display: inline-block;
					margin-left: 20px
				}
				div {
					line-height 30px;
					margin-bottom 5px;
					position relative;
				}
				/deep/.el-collapse-item__content {
					display: flex
					flex-direction column
					text-align left
					// padding-left 50px;
					padding-bottom 0px;
				}
				/deep/.el-collapse-item__header {
					font-size 16px
					font-weight 700px
				}
				/deep/.el-collapse-item__arrow {
					margin-left: 20px
				}
			}
		}
		.addr-set {
			display: inline-block;
			margin-left: 10px;
			color: var(--fx-primary-color);
			cursor: pointer;
		}
	}
}
.title{
	color:#333;
	font-size:16px;
	font-weight:bold;
	line-height: 40px
}
.content{
	line-height: 30px
}
.match-content {
	text-align: left;
	margin-bottom: 20px
}
</style>
<style lang="stylus">
.tip-modal{
	.el-dialog__body {
		padding: 10px 20px
	}
	.el-dialog__header{
		text-align: left
	}
	.el-dialog__headerbtn{
		display:none
	}
}
.addr-modal {
	.el-dialog__body {
		padding: 10px 20px
	}
	.el-dialog__header{
		text-align: left
	}
	.el-dialog__footer {
		text-align: center
	}
}
</style>

